import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

// TODO: Remove https://change.atlassian.net/browse/CHANGE-58723
import { createFcmConfig } from '../shared/factory';

export const FCM_ENABLE_TEAMS_FOR = createFcmConfig('enable_teams_for', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
